import { API, Auth } from 'aws-amplify'
import config from '../config/aws'

/**
 * Decodifica un token JWT para obtener el payload
 */
const decodeJWT = (token) => {
  try {
    const base64Url = token.split('.')[1]
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    )
    return JSON.parse(jsonPayload)
  } catch (error) {
    console.error('Error decodificando JWT:', error)
    return null
  }
}

const getExpectedIssuer = () =>
  `https://cognito-idp.${config.cognito.REGION}.amazonaws.com/${config.cognito.USER_POOL_ID}`

const isTokenValidForEnv = (token) => {
  const decodedToken = decodeJWT(token)
  if (!decodedToken) return false

  if (decodedToken.exp && decodedToken.exp * 1000 < Date.now()) {
    return false
  }

  const expectedIssuer = getExpectedIssuer()
  if (decodedToken.iss && decodedToken.iss !== expectedIssuer) {
    return false
  }

  return true
}

const clearImpersonationStorage = () => {
  localStorage.removeItem('impersonatedToken')
  localStorage.removeItem('impersonatedUserId')
  localStorage.removeItem('impersonatedEmail')
  localStorage.removeItem('impersonatedUsername')
}

/**
 * Helper para hacer peticiones API con soporte automático para impersonación
 * Usa el token del usuario impersonado si está disponible, sino usa el token del admin
 */
export const apiCall = async (method, path, options = {}) => {
  // Verificar si hay un token de impersonación guardado
  let token = localStorage.getItem('impersonatedToken')
  let isImpersonated = false

  if (token && !isTokenValidForEnv(token)) {
    console.warn(
      '[API Call] Token de impersonación inválido para este entorno. Limpiando.'
    )
    clearImpersonationStorage()
    token = null
  }

  if (!token) {
    // Si no hay token de impersonación, usar el token del usuario actual (admin)
    const user = await Auth.currentAuthenticatedUser()
    token = user.signInUserSession.idToken.jwtToken
  } else {
    isImpersonated = true
  }

  // Decodificar el token para obtener información del usuario
  const decodedToken = decodeJWT(token)
  const userId =
    decodedToken?.sub || decodedToken?.['cognito:username'] || 'unknown'
  const email = decodedToken?.email || 'unknown'

  // Log para ver qué usuario se está usando
  console.log(`[API Call] ${method.toUpperCase()} ${path}`)
  console.log(`[API Call] Usuario ID: ${userId}`)
  console.log(`[API Call] Email: ${email}`)
  console.log(`[API Call] Impersonado: ${isImpersonated ? 'SÍ' : 'NO'}`)

  // Preparar headers
  const headers = {
    Authorization: `Bearer ${token}`,
    ...options.headers
  }

  // Preparar opciones finales
  const finalOptions = {
    ...options,
    headers
  }

  // Realizar la petición
  return API[method]('rcs-api', path, finalOptions)
}

// Helpers específicos para cada método HTTP
export const apiGet = (path, options = {}) => apiCall('get', path, options)
export const apiPost = (path, options = {}) => apiCall('post', path, options)
export const apiPut = (path, options = {}) => apiCall('put', path, options)
export const apiDel = (path, options = {}) => apiCall('del', path, options)
